import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

import Link from 'client/components/aria/Link/Link';
import Button from 'client/components/aria/Button/Button';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { setAOIError } from 'client/store/mapSlice/mapSlice';
import { HELP_PAGE } from 'client/utils/routes/routeConstants';
import { mapModes } from 'client/utils/constants/appStates';

import styles from '../button.module.scss';

export const NO_OPERATIONAL_AREAS = 'No operational areas found in AOI';

const AOIErrorSnackBar = () => {
    const mapMode = useSelector(state => state.map?.mode);
    const aoiError = useSelector(state => state.map?.aoiError);
    const dispatch = useDispatch();
    const intl = useIntl();

    const handleCloseButton = () => {
        dispatch(setAOIError(null));
    };

    const snackBarVariant = () => {
        if (aoiError?.code === 403 && aoiError?.message === NO_OPERATIONAL_AREAS) {
            return 'warning';
        }
        return 'error';
    };

    const snackBarMessage = () => {
        if (aoiError?.code === 403) {
            if (aoiError?.message === NO_OPERATIONAL_AREAS) {
                return intl.formatMessage({ id: 'mapPage.error.noOperationalAreas' }, {
                    helpLink: <Link data-testid="aoiError.alert.noOperationalAreas.viewLink"
                        href={HELP_PAGE}
                        aria-label={intl.formatMessage({ id: 'errorPage.serviceDesk' })}>
                        { intl.formatMessage({ id: 'mapPage.error.noOperationalAreas.helpLink' }) }
                    </Link>
                });
            } else {
                return intl.formatMessage({ id: 'mapPage.error.forbidden' });
            }
        }
        return aoiError?.message ? aoiError.message : 'API Error';
    };

    const closeButton = <Button
        data-testid="aoiErrorSnackBar.close"
        variant="transparent"
        className={styles.button}
        onPress={() => handleCloseButton()}>
        <Icon path={mdiClose} size={1}/>
    </Button>;

    if (!aoiError || mapMode.includes(mapModes.DRAWING)) {
        return <></>;
    }

    return <SnackBar variant={snackBarVariant()} endOfLine={closeButton}
        data-testid="aoiError.alert">
        {snackBarMessage()}
    </SnackBar>;
};

export default AOIErrorSnackBar;
